import { Component } from '@angular/core';

@Component({
  selector: 'acb-alcon-message-center-grid',
  templateUrl: './message-center-grid.component.html',
  styleUrls: ['./message-center-grid.component.scss']
})
export class MessageCenterGridComponent {
}
